var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1720,
    height: 553,
    viewBox: "0 0 1720 553",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2102",
    "data-name": "Rectangle 2102",
    width: 1720,
    height: 553,
    rx: 71,
    transform: "translate(100 3392)",
    fill: "#f0f0f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_13",
    "data-name": "Groupe de masques 13",
    transform: "translate(-100 -3392)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2949",
    "data-name": "Trac\\xE9 2949",
    d: "M-8163.051,12070.1c193.2-66.693,307.528-276.243,285.518-513s14.635-161.858,183.381,141.6,67.025-623.341,584.66-507.279c288.323,64.646,292.995,319.926,155.523,492.1-109.493,137.135-229.594,218.853-336.851,235.1-242.115,36.682-572.013-199.745-273.912-253.021s565.545-97.966,464.249,438.741c-41.533,220.055,334.849-100.4,457.876-88.8s111.378,226.972,169.454,272.22",
    transform: "translate(8027.527 -8223.632)",
    fill: "none",
    stroke: "#d0d0d0",
    strokeWidth: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.6102e9941724dd8a4faf81a2e23a16e4.svg";
export { ForwardRef as ReactComponent };